import { createRoot } from "react-dom/client";

import { Provider } from "react-redux";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { SnackbarProvider } from "notistack";

// Services
import { unregister } from "./services/serviceWorker";
import "./services/i18n";

// Local
import store from "./state/store";
import theme from "./styles/theme";
import App from "./views/App";

const root = createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <SnackbarProvider maxSnack={3}>
          <App />
        </SnackbarProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  </Provider>,
);

// Disable for now, new version cache problem
// registerServiceWorker();
unregister();
